import { ClockIcon } from "lucide-react";

interface Props {
    title?: string;
    description?: string;
    interviewLanguage?: string;
    durationInMinutes?: number;
}

export default function PreviewInterviewCardHeader({ title, description, interviewLanguage = "en-US", durationInMinutes = 20 }: Props) {
    const isMalay = interviewLanguage === "Malay";
    const isIndonesian = interviewLanguage === "id-ID";

    const t = (en: string, id: string, ms: string) => {
        if (isMalay) return ms;
        if (isIndonesian) return id;
        return en;
    };

    return (
        <div className="px-0 pb-3">
            <h1 className="text-xl sm:text-3xl font-semibold sm:font-bold text-gray-900 dark:text-white mb-2">
                {title || t(
                    "Prepare for your AI Interview",
                    "Persiapkan Wawancara AI Anda",
                    "Bersedia untuk Temuduga AI Anda"
                )}
            </h1>
            <div className="flex items-center space-x-4 text-sm text-gray-600">
                <div className="flex items-center space-x-1">
                    <ClockIcon className="w-4 h-4" />
                    <span>{durationInMinutes}m</span>
                </div>
                <div className="max-w-xl">
                    {description || (
                        <>
                            {t(
                                "Please check your audio/video before starting.",
                                "Silakan periksa audio/video Anda sebelum memulai.",
                                "Sila semak audio/video anda sebelum bermula."
                            )}
                            <br />
                            {t(
                                "Please use Chrome for the best interview experience.",
                                "Silakan gunakan Chrome untuk pengalaman wawancara terbaik.",
                                "Sila gunakan Chrome untuk pengalaman temuduga terbaik."
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
